const selectArr = [
  { value: '', label: '시군구' },
  // { label: '전주시 완산구', value: '45111' },
  // { label: '전주시 덕진구', value: '45113' },
  { label: '전주시', value: '45110' },
  { label: '군산시', value: '45130' },
  { label: '익산시', value: '45140' },
  { label: '정읍시', value: '45180' },
  { label: '남원시', value: '45190' },
  { label: '김제시', value: '45210' },
  { label: '완주군', value: '45710' },
  { label: '진안군', value: '45720' },
  { label: '무주군', value: '45730' },
  { label: '장수군', value: '45740' },
  { label: '임실군', value: '45750' },
  { label: '순창군', value: '45770' },
  { label: '고창군', value: '45790' },
  { label: '부안군', value: '45800' },
]
const MODAL_WIDTH = 800
const MODAL_WIDTH_RESULT = 800

const resultArr = [
  [{ key: '지구(사업)명', value: '' }, { key: '사업년도', value: '' }],
  [{ key: '사업위치', value: '' }],
  [{ key: '사업유형', value: '' }],
  [{ key: '주요사업', value: '' }],
]

const resultArr2 = [
  [{ key: '사업대상', value: '' }],
  [{ key: '준공(예정일)', value: '' }],
]

export {
  selectArr,
  MODAL_WIDTH,
  MODAL_WIDTH_RESULT,
  resultArr,
  resultArr2,
}
